import { Component, computed, input } from '@angular/core';
import { TelephoneLinkComponent } from '../../../../../../shared/components/telephone-link/telephone-link.component';
import { MmrService } from '../../../../services/mmr.service';
import { ClaimDetailsPanelNoAllocationRules } from '../../../../types/mmr-claims.type';

@Component({
  selector: 'app-no-allocation-rules',
  imports: [TelephoneLinkComponent],
  templateUrl: './no-allocation-rules.component.html',
  styleUrl: './no-allocation-rules.component.scss',
})
export class NoAllocationRulesComponent {
  claimType = input.required<'repair' | 'service'>();

  protected viewModel = computed(() => {
    const { claims } = this.mmrService.planClaimsDetails;
    const claimValue = claims.value()?.[this.claimType()] as ClaimDetailsPanelNoAllocationRules;

    return {
      claimType: this.claimType(),
      phone: claimValue?.contactPhone,
      postCode: claims.value()?.addressInformation?.postalCode,
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(private readonly mmrService: MmrService) {}
}
